import React from 'react';

const HeroBackground = () => {
  return (
    <>
      {/* Background Image */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url("https://i.imgur.com/8rzPAVy.png")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          opacity: 0.5
        }}
      />
      
      {/* Animated Circles */}
      <div className="absolute -top-1/3 -right-1/3">
        {/* Large circle */}
        <div 
          className="absolute w-[1200px] h-[1200px] border-2 border-[#0139B7] rounded-full opacity-30 animate-float-1"
          style={{ boxShadow: '0 0 50px rgba(1,57,183,0.2)' }}
        />
        {/* Medium circle */}
        <div 
          className="absolute w-[900px] h-[900px] top-[100px] right-[100px] border-2 border-[#0139B7] rounded-full opacity-30 animate-float-2"
          style={{ 
            animationDelay: '2s',
            boxShadow: '0 0 40px rgba(1,57,183,0.25)'
          }}
        />
        {/* Small circle */}
        <div 
          className="absolute w-[600px] h-[600px] top-[200px] right-[200px] border-2 border-[#0139B7] rounded-full opacity-30 animate-float-3"
          style={{ 
            animationDelay: '1s',
            boxShadow: '0 0 30px rgba(1,57,183,0.3)'
          }}
        />
      </div>

      <div className="absolute -bottom-1/1 -left-1/3">
        {/* Large circle */}
        <div 
          className="absolute w-[1200px] h-[1200px] border-2 border-[#0139B7] rounded-full opacity-30 animate-float-1"
          style={{ boxShadow: '0 0 50px rgba(1,57,183,0.5)' }}
        />
        {/* Medium circle */}
        <div 
          className="absolute w-[900px] h-[900px] top-[100px] left-[100px] border-2 border-[#0139B7] rounded-full opacity-30 animate-float-2"
          style={{ 
            animationDelay: '2s',
            boxShadow: '0 0 40px rgba(1,57,183,0.25)'
          }}
        />
        {/* Small circle */}
        <div 
          className="absolute w-[600px] h-[600px] top-[200px] left-[200px] border-2 border-[#0139B7] rounded-full opacity-30 animate-float-3"
          style={{ 
            animationDelay: '1s',
            boxShadow: '0 0 30px rgba(1,57,183,0.3)'
          }}
        />
      </div>

      {/* Glow Effects */}
      <div className="absolute -top-40 -right-40 w-96 h-96 bg-gradient-to-r from-[#0139B7] to-[#0156e0] rounded-full 
        filter blur-3xl opacity-20 animate-pulse" />
      <div className="absolute bottom-40 -left-40 w-96 h-96 bg-gradient-to-r from-[#0156e0] to-[#0139B7] rounded-full 
        filter blur-3xl opacity-20 animate-pulse-delayed" />
      <div className="absolute -bottom-20 left-1/2 -translate-x-1/2 w-[40rem] h-80 bg-gradient-to-r from-[#0139B7] via-[#0156e0] to-[#0139B7] rounded-full 
        filter blur-3xl opacity-15 animate-pulse"
        style={{ animationDelay: '1s' }}
      />
    </>
  );
};

export default HeroBackground;